import styled from 'styled-components';

import { Flex } from '@/components/base';

const UploadLayout = styled(Flex)`
  height: 100%;
  flex-direction: column;
`;

const HeaderArea = styled.div`
  width: 100%;
  height: 56px;
  box-shadow: inset 0px -1px 0px ${(props) => props.theme.colors.gray400};
  border-radius: 0px 4px 0px 0px;
`;

const BodyArea = styled.div`
  width: 100%;
  height: calc(100% - 56px);
`;

const UploadStyles = {
  UploadLayout,
  HeaderArea,
  BodyArea,
};

export default UploadStyles;
